import { EMPTY_LIST } from '../../../constants/common'
import {
  TableDateCell,
  TableServiceRequestCell,
  TableUserCell,
  toTableCellMultiValue,
} from '../../Table'
import { toUserMultiValue } from '../../User'
import { ChatTableCellName } from '../Chat.constants'
import { isChatUnread } from '../Chat.utils'
import { ChatTableRowBuildings } from '../ChatTableRowBuildings'
import { ChatTableRowLastMessage } from '../ChatTableRowLastMessage'
import { ChatTableRowLastMessageDate } from '../ChatTableRowLastMessageDate'
import { ChatTableRowParticipants } from '../ChatTableRowParticipants'
import { ChatTableRowTitle } from '../ChatTableRowTitle'

export function checkIsRowFocused(item, focusedRow) {
  return item.uuid === focusedRow
}

export function renderCell({ item, name, scrollRef, ...restProps }) {
  const { [name]: value } = item

  const unread = isChatUnread(item)

  switch (name) {
    case ChatTableCellName.Title:
      return <ChatTableRowTitle {...restProps} item={item} unread={unread} />
    case ChatTableCellName.LastMessage:
      return (
        <ChatTableRowLastMessage
          {...restProps}
          item={item}
          scrollRef={scrollRef}
          unread={unread}
        />
      )
    case ChatTableCellName.LastMessageDate:
      return (
        <ChatTableRowLastMessageDate
          {...restProps}
          item={item}
          unread={unread}
        />
      )
    case ChatTableCellName.Participants:
      return (
        <ChatTableRowParticipants
          {...restProps}
          item={item}
          scrollRef={scrollRef}
          unread={unread}
        />
      )

    case ChatTableCellName.Buildings:
      return (
        <ChatTableRowBuildings
          {...restProps}
          scrollRef={scrollRef}
          unread={unread}
          value={value}
        />
      )

    case ChatTableCellName.Requests:
      return (
        <TableServiceRequestCell
          {...restProps}
          items={value || EMPTY_LIST}
          scrollRef={scrollRef}
          unread={unread}
        />
      )
    case ChatTableCellName.CreatedBy:
    case ChatTableCellName.UpdatedBy:
      return (
        <TableUserCell
          {...restProps}
          value={value ? toUserMultiValue(value) : null}
        />
      )
    case ChatTableCellName.Updated:
    case ChatTableCellName.Created:
      return <TableDateCell {...restProps} unread={unread} value={value} />
  }
}

export function toChatTableRowBuildingCellData(data) {
  return {
    ...toTableCellMultiValue(data.title),
    key: data.id,
    src: data.avatar,
  }
}
